import * as ActionTypes from './actionTypes'

export function setGenerateNewSessionFlag(payload: any){
	return {
		type : ActionTypes.SET_GENERATE_NEW_SESSION_FLAG,
		payload
	}
}

export function setStateForNewSession(payload: any){
	return {
		type : ActionTypes.SET_STATE_FOR_NEW_SESSION,
		payload
	}
}

export function setResetFunctionFlag(stateLocation: any, value: any){
    return {
        type : ActionTypes.SET_RESET_FUNCTION_FLAG,
        payload : {
			stateLocation,
			value
        }
    }
}



// WEBPACK FOOTER //
// ./modules/generate-new-session/actions/actions.ts